/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { getContentNameFromWidgetName } from '@/data/utils/getContentNameFromWidgetName';
import { Layout } from '@/data/types/Layout';
import { getLayoutForContainer } from '@/data/containers';
import { IncomingContent } from '@/data/types/IncomingContent';

export const getNormalizedLayout = (props: IncomingContent): Layout | undefined => {
	const { layout } = props;

	if (layout?.containerName) {
		const layoutFromContainer = getLayoutForContainer(
			getContentNameFromWidgetName(layout.containerName),
			{ ...props, layout }
		);

		if (layoutFromContainer) {
			return layoutFromContainer;
		}

		if (layout.containerName === 'ContentPageContainer') {
			return getLayoutForContainer('HomePage', { ...props, layout });
		}
	}

	if (layout?.name) {
		return getLayoutForContainer(layout.name, { ...props, layout });
	}

	return undefined;
};
